import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../components/general/Image';
import backgroundImage from '../../assets/home/CaseStudyBackground.png';
import CaseStudy1 from '../../assets/home/case-study1.png';
import CaseStudy2 from '../../assets/home/case-study2.png';
import CaseStudy3 from '../../assets/home/case-study3.png';
import CaseStudy4 from '../../assets/home/case-study4.png';
import Button from '../../components/general/Button';

const CaseStudies = () => {
  const backgroundStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'initial',
    backgroundRepeat: 'no-repeat',
  }

  const navigate = useNavigate()

  return (
    <section style={backgroundStyle}>
      <div className="--layout-padding max-width grid grid-cols-2 items-center gap-4 !py-[50px] md:grid-cols-3 lg:flex lg:gap-0 lg:justify-between">      
        <Image className="w-[130px]" src={CaseStudy1} alt=""/>
        <Image className="w-[200px]" src={CaseStudy2} alt=""/>
        <Image className="w-[200px]" src={CaseStudy3} alt=""/>
        <Image className="w-[200px]" src={CaseStudy4} alt=""/>
        <Button className="btn btn-outline-white col-span-2 lg:col-span-1 border border-white rounded lg:w-[200px] lg:h-[50px] text-black" href={"#"}>Our Case studies <i className="fa-solid fa-arrow-up-right" /></Button>
      </div>
    </section>
  );
};

export default CaseStudies;